// @ts-nocheck
// Fill the whole builder from a JSON export: paste it, or drop a .json file.
import { useRef, useState } from 'react';
import { AlertCircle, Check, Upload } from 'lucide-react';
import { c, Modal, Message } from './ui/ui';
import { parseAgentJson } from './agentPayload';

export default function ImportJsonDialog({ open, onOpenChange, onImport, options }) {
  const onClose = () => onOpenChange(false);
  const [text, setText] = useState('');
  const [fileName, setFileName] = useState('');
  const [error, setError] = useState('');
  const [preview, setPreview] = useState(null);
  const fileRef = useRef(null);

  const reset = () => {
    setText('');
    setFileName('');
    setError('');
    setPreview(null);
  };
  const close = () => {
    reset();
    onClose();
  };

  const check = (value) => {
    setText(value);
    setError('');
    setPreview(null);
    if (!value.trim()) return;
    try {
      setPreview(parseAgentJson(value, options));
    } catch (err) {
      setError(err.message);
    }
  };
  const readFile = async (file) => {
    if (!file) return;
    setFileName(file.name);
    check(await file.text());
  };
  const apply = () => {
    if (!preview) return;
    onImport(preview);
    close();
  };

  return (
    <Modal
      open={open}
      onClose={close}
      wide
      title="Import agent JSON"
      sub="Fill the whole form from an exported agent. Nothing is saved until you publish."
      footer={
        <>
          <span className={c('note')} style={{ marginRight: 'auto' }}>
            The agent id and status in the file are ignored. This agent keeps its own id.
          </span>
          <button type="button" className={c('btn')} onClick={close}>
            Cancel
          </button>
          <button type="button" className={c('btn primary')} disabled={!preview} onClick={apply}>
            Fill the form
          </button>
        </>
      }
    >
      <div
        className={c('drop')}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          readFile(e.dataTransfer.files?.[0]);
        }}
      >
        <Upload className="ags-i" />
        <div style={{ fontWeight: 650, color: 'var(--text)', marginTop: 6 }}>Drop a .json file here</div>
        <div style={{ marginTop: 4 }}>
          or{' '}
          <button type="button" className={c('btn small')} style={{ marginLeft: 6 }} onClick={() => fileRef.current?.click()}>
            Choose file
          </button>
        </div>
        <input ref={fileRef} type="file" accept="application/json,.json" hidden onChange={(e) => readFile(e.target.files?.[0])} />
        {fileName && <div style={{ marginTop: 6 }}>{fileName}</div>}
      </div>

      <div className={c('field')}>
        <label htmlFor="ags-json">Or paste JSON</label>
        <textarea
          id="ags-json"
          className={c('ctl mono', error && 'invalid')}
          rows={6}
          spellCheck={false}
          value={text}
          placeholder='{ "agent_name": "Hotel Bot", "voice_id": 7, ... }'
          onChange={(e) => check(e.target.value)}
        />
        <Message error={error} ok={preview ? 'Valid agent JSON' : ''} />
      </div>

      {preview && (
        <div className={c('prev')}>
          <Check className="ags-i" />
          <div>
            <b>Ready to fill: {preview.state.agentName}</b>
            <small>
              {preview.state.instructions.length} instruction(s), {preview.state.functions.length} function(s),{' '}
              {preview.state.laya.answers.length} fast answer(s), {preview.state.completionRules.length} completion rule(s)
            </small>
            {preview.warnings.map((w) => (
              <div className={c('w')} key={w}>
                <AlertCircle className="ags-i" />
                <span>{w}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
}
